import { FileTextIcon, ZapIcon, ActivityIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, FlaskConicalIcon, LeafIcon, DownloadIcon } from 'lucide-react';
export const heroSeals = [{
  icon: FlaskConicalIcon,
  label: 'Scientific Approach'
}, {
  icon: LeafIcon,
  label: '100% Natural'
}, {
  icon: DownloadIcon,
  label: 'Instant Digital Access'
}];
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF & Printable'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: ActivityIcon,
  label: 'All menopause stages'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: ZapIcon,
  label: 'Lifetime Access'
}];
export const stats = [{
  value: '550+',
  label: 'Happy transformed women'
}, {
  value: '6 + 3',
  label: "Volumes + Bonuses"
}, {
  value: '4.9/5',
  label: 'Rating ⭐⭐⭐⭐⭐'
}, {
  value: '99%',
  label: 'Would recommend it'
}];